const question3 = {
    'question': 'Do kogo jest skierowana psychoterapia systemowa?',
    'answer': 'Psychoterapia systemowa jest skierowana do rodzin, które chcą poprawić swoje relacje i rozwiązać problemy, które je trapią. Możliwe jest również podjęcie terapii systemowej przez małżonków lub rodziców z dziećmi.',
}

export default question3;